import axios from 'api/axios'

export interface DeactivateSignalsResponse {
	success: boolean
	message: string
}

const deactivateSignalsForUser = async (
	clientId: string,
	adminId: string
): Promise<DeactivateSignalsResponse> => {
	const { data } = await axios.post<DeactivateSignalsResponse>(
		`api/signals/deactivate/by-client/${adminId}?clientId=${encodeURIComponent(
			clientId
		)}`
	)
	return data
}

export default deactivateSignalsForUser
